module.exports = "/_next/static/images/Hero@2x-971e4400f6dbee06ba4760e42fa518f5.webp";